import { cx, focusRing } from "components/Graphs/utils";
import { Route, Switch, useLocation } from "react-router-dom";
import React, { useContext, useEffect } from "react";
import { UserContext } from "contexts/UserContext";
import { isKasAuthFlow } from "server/kas/utils";

const RedirectFromConsole: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  useEffect(() => {
    if (!isKasAuthFlow) {
      window.location.href =
        "https://brev.nvidia.com" +
        window.location.pathname +
        window.location.search;
    }
  }, []);
  return <>{children}</>;
};

export default RedirectFromConsole;
